import ApiService from "../api";

export default class FaltaService extends ApiService {

    constructor() {
        super("/api/faltas");
    }

    listar({ inicio, fim, funcionarioId, filialId } = {}) {
        const params = new URLSearchParams();
        params.append('inicio', inicio);
        params.append('fim', fim);

        if (funcionarioId) params.append("funcionarioId", funcionarioId);
        if (filialId) params.append("filialId", filialId);

        return this.get(`?${params.toString()}`);
    }


    listarAfastamentos(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);

        if (values.funcionarioId) params.append('funcionarioId', values.funcionarioId);

        return this.get(`/buscar-afastamentos?${params.toString()}`)
    }

    buscarPorId(id) {
        return this.get(`/${id}`);
    }

    registrar(dto) {
        return this.post("", dto);
    }

    registrarPorFuncionario(dto) {
        return this.post("/por-funcionario", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    remover(id) {
        return this.delete(`/${id}`);
    }

    // Importa as faltas direto da folha do Fortes (apaga antes as faltas de origem Fortes do período).
    // Sem filialId sincroniza todas as filiais com empresa/estabelecimento do Fortes configurados.
    sincronizarFortes({ inicio, fim, filialId }) {
        const params = new URLSearchParams();
        params.append('inicio', inicio);
        params.append('fim', fim);
        if (filialId) params.append('filialId', filialId);

        return this.post(`/sincronizar-fortes?${params.toString()}`, null);
    }

    importarExcel(file) {
        return this.post(`/importar`, file)
    }

}